import styled from "styled-components"

const Subheading = styled.div`
  color: ${props => props.theme.color.primaryText};
  font-size: 20px;
  margin: 4px 0;
`

export default Subheading
